const {store} = aofljs;
import mutations from './mutations';

const NAMESPACE = 'createShortcutPcPopup';
const ALIAS = 'createShortcutPcPopup';

let sdo = {
  namespace: NAMESPACE,
  alias: ALIAS,
  mutations: mutations
};

store.addState(sdo);



// WEBPACK FOOTER //
// ./home/en-US/js/create-shortcut-pc-popup/sdo/index.js